(function componentForm($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");
	var form = {
		name: 'AgentsImagineWeddingsCertification',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$("a.info-link").on('click', function showInfo(e)
		{
			var $self = $(this),
			    title = $self.data('modal-title'),
			    body  = $self.data('content') || $($self.data('modal-id')).html();

			e.preventDefault();
			$modal.find('.modal-title').text(title);
			$modal.find('.modal-body').html(body);
			$modal.modal('show');
		});

		$('#agentsimagineweddingscertification-certification_options').on('change', function click(e)
		{
			var certification         = $(this).find('option:selected').val(),
			    $new                  = $("#new"),
			    $certified            = $("#certified"),
			    $currently_certified  = $("#currently_certified"),
			    $currently_certified2 = $("#currently_certified2"),
			    $form_notice          = $("#form_notice"),
			    $certification_submit = $("#certification_submit");

			switch (certification) {
				case 'new':
					// new to certified DWD
					$form_notice.removeClass('hidden');

					$new.removeClass('hidden').find('input').prop('disabled', false);
					$new.find('select').prop('disabled', false);
					$new.find('textarea').prop('disabled', false);

					$certified.addClass('hidden').find('input').prop('disabled', true);
					$certified.find('select').prop('disabled', true);
					$certified.find('textarea').prop('disabled', true);

					$currently_certified.addClass('hidden').find('input').prop('disabled', true);
					$currently_certified2.addClass('hidden').find('input').prop('disabled', true);
					$certification_submit.removeClass('disabled');
					break;
				case 'certified':
					// new to certified DWD 2.0
					$form_notice.removeClass('hidden');

					$certified.removeClass('hidden').find('input').prop('disabled', false);
					$certified.find('select').prop('disabled', false);
					$certified.find('textarea').prop('disabled', false);

					$new.addClass('hidden').find('input').prop('disabled', true);
					$new.find('select').prop('disabled', true);
					$new.find('textarea').prop('disabled', true);

					$currently_certified.addClass('hidden').find('input').prop('disabled', true);
					$currently_certified2.addClass('hidden').find('input').prop('disabled', true);
					$certification_submit.removeClass('disabled');
					break;
				case 'currently_certified':
					// already certified in DWD
					$form_notice.removeClass('hidden');
					$currently_certified.removeClass('hidden').find('input').prop('disabled', false);

					$new.addClass('hidden').find('input').prop('disabled', true);
					$new.find('select').prop('disabled', true);
					$new.find('textarea').prop('disabled', true);

					$certified.addClass('hidden').find('input').prop('disabled', true);
					$certified.find('select').prop('disabled', true);
					$certified.find('textarea').prop('disabled', true);

					$currently_certified2.addClass('hidden').find('input').prop('disabled', true);
					$certification_submit.removeClass('disabled');
					break;
				case 'currently_certified2':
					// already certified in DWD 2.0
					$form_notice.removeClass('hidden');
					$currently_certified2.removeClass('hidden').find('input').prop('disabled', false);
					$currently_certified.addClass('hidden').find('input').prop('disabled', true);

					$new.addClass('hidden').find('input').prop('disabled', true);
					$new.find('select').prop('disabled', true);
					$new.find('textarea').prop('disabled', true);

					$certified.addClass('hidden').find('input').prop('disabled', true);
					$certified.find('select').prop('disabled', true);
					$certified.find('textarea').prop('disabled', true);

					$certification_submit.removeClass('disabled');
					break;
				default:
					// nothing selected
					$form_notice.addClass('hidden');

					$new.addClass('hidden').find('input').prop('disabled', true);
					$new.find('select').prop('disabled', true);
					$new.find('textarea').prop('disabled', true);

					$certified.addClass('hidden').find('input').prop('disabled', true);
					$certified.find('select').prop('disabled', true);
					$certified.find('textarea').prop('disabled', true);

					$currently_certified.addClass('hidden').find('input').prop('disabled', true);
					$currently_certified2.addClass('hidden').find('input').prop('disabled', true);
					$certification_submit.addClass('disabled');
					break;
			}
		});

		$('#agentsimagineweddingscertification-new-none').click(function click(e)
		{
			var $percentage_booked_options = $("#percentage_booked_options"),
			    market_share_none          = $('#agentsimagineweddingscertification-new-none').prop('checked');

			if (market_share_none === true) {
				$percentage_booked_options.find('select').prop('disabled', true);
			} else {
				$percentage_booked_options.find('select').prop('disabled', false);
			}
		});
	};
}(jQuery, window.Adzuki || {}));
